import React, {createContext, useReducer, useEffect} from "react";
import {UserReducer, initial_state} from "@reducers/user.reducer";
import cookie from "react-cookies";
import {isEmpty} from "@helpers/helpers";
import {getUserInfo} from "../../models/user";

export const UserContext = createContext();
export const UserDispatcherContext = createContext();

export default function UserProvider({children}) {
    const [userState, userDispatcher] = useReducer(UserReducer, initial_state);

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        const authTokenStorage = localStorage.getItem('auth_token');
        const authTokenCookie = cookie.load('auth_token');

        if (!isEmpty(authTokenCookie)) {
            if (!isEmpty(storedUser) && authTokenStorage === authTokenCookie) {
                userDispatcher({
                    type: 'STORE_USER',
                    payload: {
                        token: authTokenCookie,
                        user: JSON.parse(storedUser),
                        storeTokenInCookie: false
                    },
                });
            } else {
                getUserInfo().then(result => {
                    userDispatcher({
                        type: 'STORE_USER',
                        payload: {
                            user: result,
                            token: authTokenCookie,
                            storeTokenInCookie: false
                        },
                    });
                }).catch(err => {
                    userDispatcher({
                        type: 'LOGOUT',
                        payload: {},
                    });
                });
            }
        } else {
            userDispatcher({
                type: 'LOGOUT',
                payload: {},
            });
        }

    }, []);
    return (
        <UserContext.Provider value={userState}>
            <UserDispatcherContext.Provider value={userDispatcher}>
                {children}
            </UserDispatcherContext.Provider>
        </UserContext.Provider>
    )
}